import BaseModulePlugins from '@/store/baseModule/plugins';
import BaseModule from '@/store/baseModule/index';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';

export default (store) => {
  store.registerModule(
    ['actionplans', 'types'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({
          url: `${process.env.MYPREDITY_BASE_URI}/actionplans/types`,
        }),
        retry: { nbLeft: 3, timeout: 2000 },
      }),
    })
  );
  const basePlugin = new BaseModulePlugins({
    module: 'actionplans/types',
    paramId: null,
    store,
  });
  basePlugin.onInit(() => store.dispatch('actionplans/types/initItems'));
};
